import { useState } from 'react'
import {
  Box,
  Button,
  Image,
  Input
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import { COLORS } from 'utils/styles'

export const Wallet = ({
  walletAddress,
  setWalletAddress
}) => {
  const [showInput, setShowInput] = useState(false)
  const [btnZINdex, setBtnZINdex] = useState(2)

  return (
    <Box position="relative">
      <Button
        backgroundColor={COLORS.gold}
        _hover={{ background: COLORS.gold_hover }}
        width="100%"
        position="absolute"
        zIndex={btnZINdex}
        fontWeight="400"
        fontSize="18px"
        opacity={showInput ? 0 : 1}
        transition="opacity 1s ease"
        onClick={() => {
          setShowInput(true)
          setTimeout(() => setBtnZINdex(0), 1000)
        }}
      >
        Connect Wallet
        <Image
          boxSize="23px"
          margin={1}
          objectFit="cover"
          src={ImagesPng.LogoHeader}
          alt="Logo"
          borderRadius="full"
        />
      </Button>

      <Box>
        <Input
          backgroundColor={COLORS.gold}
          _hover={{ background: COLORS.gold_hover }}
          placeholder="Paste your CNCTR address here"
          _placeholder={{
            color: 'white',
            textAlign: 'center',
            fontSize: '18px'
          }}
          value={walletAddress ?? ''}
          onChange={(e) => setWalletAddress(e.target.value)}
        />
      </Box>
    </Box>
  )
}
